function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-logo-1{fill:#fff;}.cls-logo-2{fill:#b3b3b3;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-logo-1",
  d: "M334,366a9.15,9.15,0,0,1-9.14-9.15V242.45a9.15,9.15,0,1,1,18.29,0V356.87A9.15,9.15,0,0,1,334,366Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-logo-1",
  d: "M379.64,365.92a9.15,9.15,0,0,1-9.15-9.14V196.69a9.15,9.15,0,0,1,18.3,0V356.78A9.15,9.15,0,0,1,379.64,365.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-logo-1",
  d: "M242.42,365.92a9.13,9.13,0,0,1-9.15-9.14V35.07L135.19,156.69A9.15,9.15,0,0,1,118.92,151V34.74C103.82,53.25,89.6,70.88,75.73,88.08,57,111.33,37.59,135.38,16.21,161.34A9.15,9.15,0,1,1,2.09,149.7c21.31-25.88,40.68-49.89,59.4-73.11S99.63,29.29,121,3.34a9.15,9.15,0,0,1,16.21,5.81V125L235.3,3.41a9.15,9.15,0,0,1,16.27,5.74V334.69l34.7-34.7a9.15,9.15,0,0,1,12.93,12.94l-50.31,50.31A9.15,9.15,0,0,1,242.42,365.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-logo-2",
  d: "M507.41,110.1a9.14,9.14,0,0,1-8.64-6.15,123.58,123.58,0,0,0-10.8-23,133.18,133.18,0,0,0-44-44.6l-4.38-2.24c-3.38-1.74-6.57-3.39-9.82-4.83-21.88-9.68-53.69-8.61-76.53-5.84a9.15,9.15,0,1,1-2.21-18.16c26.16-3.17,61.21-3.76,86.14,7.27,3.75,1.66,7.34,3.51,10.81,5.3,1.52.78,3,1.57,4.57,2.33.25.13.5.27.74.42a151.36,151.36,0,0,1,50.35,50.93A141.67,141.67,0,0,1,516.05,98a9.15,9.15,0,0,1-5.64,11.64A9.3,9.3,0,0,1,507.41,110.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-logo-2",
  d: "M465.38,141.28a9.17,9.17,0,0,1-8.78-6.59,62,62,0,0,0-2.62-7.45c-8.18-18.73-20.47-32.34-38.65-42.82-.57-.29-1.23-.63-2-1-2-1.05-4.47-2.35-6.94-3.4a87.3,87.3,0,0,0-31.65-6.76,71.31,71.31,0,0,0-19.88,1.94,9.15,9.15,0,0,1-4.46-17.74,89.3,89.3,0,0,1,25-2.49,106.82,106.82,0,0,1,38.15,8.22c3.16,1.34,6.13,2.89,8.3,4l1.88,1,.46.25c21.58,12.38,36.8,29.22,46.52,51.48a78.76,78.76,0,0,1,3.43,9.66,9.16,9.16,0,0,1-8.79,11.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-logo-2",
  d: "M422.89,165.21a9.15,9.15,0,0,1-8.85-6.86c-3.13-12.14-10.53-21.65-22.62-29.09a47.38,47.38,0,0,0-29.36-5.51,33.65,33.65,0,0,0-6.87,1.77,9.15,9.15,0,0,1-6.12-17.24,52.12,52.12,0,0,1,10.62-2.68,65.57,65.57,0,0,1,40.93,7.86c16.48,10.11,26.82,23.61,31.13,40.32a9.14,9.14,0,0,1-6.57,11.14A9,9,0,0,1,422.89,165.21Z"
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 516.56 366.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.73bf7f31.svg";
export { ForwardRef as ReactComponent };